export default __webpack_public_path__ + "place.27806cc3e9e4cc6b.svg";